export default __webpack_public_path__ + "static/media/handtalk_hd.9dc207c5.svg";